/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { FilterChipBarV2 } from '../../../../../components/v2';
import {
  SERVICOS_PRIORIDADE_CHIPS,
  SERVICOS_STATUS_CHIPS,
  SERVICOS_TIPO_CHIPS,
} from '../../utils/servicosFilters';
import {
  EMPTY_MTBT_QUICK_FILTER,
  isMtBtFilterActive,
  MTBT_STATUS_CHIPS,
} from '../utils/mtbtServicosFilters';

const TIPO_CHIPS = [
  { id: SERVICOS_TIPO_CHIPS.SERVICE, label: 'Serviço' },
  { id: SERVICOS_TIPO_CHIPS.FOTO_INICIO, label: 'Foto Inicial' },
  { id: SERVICOS_TIPO_CHIPS.FOTO_FIM, label: 'Foto Final' },
  { id: SERVICOS_TIPO_CHIPS.ANALISE, label: 'Análise de Risco' },
];

const PRIORIDADE_CHIPS = [
  { id: SERVICOS_PRIORIDADE_CHIPS.E, label: 'Emergencial (E)' },
  { id: SERVICOS_PRIORIDADE_CHIPS.P1, label: '1' },
  { id: SERVICOS_PRIORIDADE_CHIPS.P2, label: '2' },
  { id: SERVICOS_PRIORIDADE_CHIPS.P3, label: '3' },
  { id: SERVICOS_PRIORIDADE_CHIPS.P4, label: '4' },
];

const STATUS_CHIPS = [
  { id: SERVICOS_STATUS_CHIPS.PENDENTE, label: 'Pendente' },
  { id: SERVICOS_STATUS_CHIPS.DIGITADA, label: 'Digitada' },
];

const MTBT_EXTRA_CHIPS = [
  { id: MTBT_STATUS_CHIPS.ERRO_INTEGRACAO, label: 'Erro integração' },
];

const toggleChip = (value, field, chipId) => ({
  ...value,
  [field]: value[field] === chipId ? null : chipId,
});

const MtBtQuickFilters = ({
  value,
  onChange,
  totalCount,
  filteredCount,
  showDigitadosPorMim,
}) => {
  const [searchInput, setSearchInput] = useState(value.search || '');

  useEffect(() => {
    setSearchInput(value.search || '');
  }, [value.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== value.search) {
        onChange({ ...value, search: searchInput });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput, onChange, value]);

  const handleClear = () => {
    setSearchInput('');
    onChange(EMPTY_MTBT_QUICK_FILTER);
  };

  const filterActive = isMtBtFilterActive(value);

  const chipGroups = useMemo(() => {
    const groups = [
      {
        label: 'Tipo',
        chips: TIPO_CHIPS.map((chip) => ({
          id: chip.id,
          label: chip.label,
          selected: value.tipoChip === chip.id,
          onClick: () => onChange(toggleChip(value, 'tipoChip', chip.id)),
        })),
      },
      {
        label: 'Prioridade',
        chips: PRIORIDADE_CHIPS.map((chip) => ({
          id: chip.id,
          label: chip.label,
          selected: value.prioridadeChip === chip.id,
          onClick: () => onChange(toggleChip(value, 'prioridadeChip', chip.id)),
        })),
      },
      {
        label: 'Status',
        chips: STATUS_CHIPS.map((chip) => ({
          id: chip.id,
          label: chip.label,
          selected: value.statusChip === chip.id,
          onClick: () => onChange(toggleChip(value, 'statusChip', chip.id)),
        })),
      },
      {
        label: 'Integração',
        chips: MTBT_EXTRA_CHIPS.map((chip) => ({
          id: chip.id,
          label: chip.label,
          selected: value.mtbtChip === chip.id,
          onClick: () => onChange(toggleChip(value, 'mtbtChip', chip.id)),
        })),
      },
    ];

    if (showDigitadosPorMim) {
      groups.push({
        label: 'Participação',
        chips: [{
          id: MTBT_STATUS_CHIPS.DIGITADOS_POR_MIM,
          label: 'Digitados por mim',
          selected: value.mtbtChip === MTBT_STATUS_CHIPS.DIGITADOS_POR_MIM,
          onClick: () => onChange(toggleChip(value, 'mtbtChip', MTBT_STATUS_CHIPS.DIGITADOS_POR_MIM)),
        }],
      });
    }

    return groups;
  }, [value, onChange, showDigitadosPorMim]);

  return (
    <FilterChipBarV2
      searchLabel="Buscar"
      searchValue={searchInput}
      onSearchChange={setSearchInput}
      searchPlaceholder="N° serviço, serviço, tipo, NSMP programada ou nova"
      chipGroups={chipGroups}
      chipGroupsLayout="row"
      filterActive={filterActive}
      filteredCount={filteredCount}
      totalCount={totalCount}
      countLabel="itens"
      onClear={handleClear}
    />
  );
};

MtBtQuickFilters.propTypes = {
  value: PropTypes.shape({
    search: PropTypes.string,
    tipoChip: PropTypes.string,
    prioridadeChip: PropTypes.string,
    statusChip: PropTypes.string,
    mtbtChip: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  filteredCount: PropTypes.number.isRequired,
  showDigitadosPorMim: PropTypes.bool,
};

MtBtQuickFilters.defaultProps = {
  showDigitadosPorMim: false,
};

export default MtBtQuickFilters;
